//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PreloaderComponent from "@/components/common/PreloaderComponent";

export default {
  name: "ProductMediaRender",
  components: {
    PreloaderComponent,
  },
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    renderImages: {
      type: Array,
      default() {
        return []
      }
    },
    renderIndex: {
      type: Number,
      default: 0
    },
    showEngravingPlaceholder: {
      type: Boolean,
      default: false,
    },
    mt: {
      type: String,
      default: '',
    },
    stage: {
      type: String,
      default: 'configuration-edit',
    },
  },
  data() {
    return {
      renderLoaded: false,
      reducedProductCategories: [
        'rings',
        'earrings'
      ],
    }
  },
  watch: {
    info: {
      async handler(value) {
        await this.imagesGroupLoading();
      },
      immediate: true,
    },
    async stage(val, oldVal) {
      if (!this.isBoxProduct && (val === 'box' || oldVal === 'box')) {
        await this.imagesGroupLoading();
      }
    },
  },
  computed: {
    engravingHandwritingFile() {
      return this.info.engraving_configs?.[0]?.engraving_images?.[this.info.engraving_handwriting_file ? 'handwriting' : 'all_yours']?.[this.mt];
    },
    isBoxProduct() {
      return this.info.theme.id === this.$productServiceData.productThemesList.package;
    },
    isSignatureNecklace() {
      return this.info.vendor_model?.toLowerCase() === 'sonlsgchn';
    },
    showCanvas() {
      let result = true;
      if (this.isBoxProduct && this.renderIndex) {
        result = false;
      }
      return result;
    },
    canvasProperties() {
      const properties = {
        class: '',
        width: 1200,
        height: 1000
      }
      if (this.isBoxProduct) {
        properties.class = 'canvasBox';
        properties.width = 600;
        properties.height = 1200;
      }
      if (this.isSignatureNecklace) {
        properties.class = 'h-100p';
      }
      return properties;
    },
    alignTop() {
      return this.info.theme.id === this.constProductThemes().necklaceMain;
    },
    reducedProduct() {
      return this.reducedProductCategories.includes(this.info.category_code);
    },
  },
  methods: {
    async imagesGroupLoading() {
      this.renderLoaded = false;
      await this.$nextTick();
      const renderImageArray = Promise.all(this.renderImages.map(item => this.loadImage(item)));
      await renderImageArray;
      await this.$nextTick();
      this.renderLoaded = true;
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve(img);
        };
        img.onerror = () => {
          resolve(null);
        };
        img.src = url;
      });
    },
  },
}
